/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * ToogleHeaderStyle.js
 */
import { useEffect, useState } from 'react';

/**
 * Toggle .header-scrolled class to #header when page is scrolled
 */
const ToogleHeaderStyle = () => {
  const [headerStyle, setHeaderStyle] = useState(null);

  // Similar to componentDidMount and componentDidUpdate.
  // Runs both after the first render
  useEffect(() => {
    // Runs after every update
    const updateHeaderStyle = () => {
      if (window.scrollY > 100) {
        setHeaderStyle('header-scrolled');
      } else {
        setHeaderStyle();
      }
    };

    window.addEventListener('scroll', updateHeaderStyle);

    // Cleanup
    return () => window.removeEventListener('scroll', updateHeaderStyle);
  }, []);
  // Run the effect and clean it up only once (on mount and unmount).
  // If you pass an empty array ([]), the props and state inside the effect will always have their initial values.

  return headerStyle;
};

export default ToogleHeaderStyle;
